import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const activityDataClassName = DataClassName.ACTIVITY
const activityEndpoint = PisaDataClassEndpoint.ACTIVITY

export function pisaActivityDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(activityDataClassName, {
    title: activityDataClassName,
    restApi: createPisaRestApiConfig(activityEndpoint),
    attributes,
  })
}
